// --------------------------------------------------------------
// Created On: 2026-10-27
// Author: Zachary Thomas
//
// Last Modified: 2026-10-27
// Modified By: Zachary Thomas
//
// Copyright 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import calculateHighlightColor from "src/utilities/calculateHighlightColor";
import stringIsValidNumber from "src/utilities/stringIsValidNumber";

// Given the highlighting rules of an attribute and its current value. Return the color to highlight the current value
// with, or null if no rule applies. Rules are in priority order, so the first matching rule wins.
export default function calculateAttributeHighlightColor(
  highlightingRules: HighlightingRule[],
  value: string | null
): string | null {
  if (value === null || highlightingRules.length === 0) {
    return null;
  }

  // Booleans are highlighted as numbers.
  let numericString = value;
  if (value.toLowerCase() === "true") {
    numericString = "1";
  } else if (value.toLowerCase() === "false") {
    numericString = "0";
  }
  if (!stringIsValidNumber(numericString)) {
    return null;
  }

  // The color calculation lets the last matching rule win, so reverse the rules to give the first rule priority.
  const orderedRules = [...highlightingRules].sort((a, b) => a.sortPriority - b.sortPriority).reverse();
  return calculateHighlightColor(orderedRules, parseFloat(numericString));
}

interface HighlightingRule {
  comparator: string;
  value: string;
  valueType: string;
  colorHexCode: string;
  sortPriority: number;
}
